module.exports = __webpack_public_path__ + "static/media/setup-hero-1.a0910618.jpg";